import PropTypes from 'prop-types';
import SubmitButton from '@/components/core/form/SubmitButton';
import ProjectTargetField from './ProjectTargetField';

const BulkDuplicateModal = ({
  count,
  defaultProjectId,
  isPending = false,
  isProjectsLoading = false,
  initialNextPage = null,
  onClose,
  onSubmit,
  open,
  resourceLabel,
  projects = [],
}) => {
  const isSubmitDisabled = isPending || isProjectsLoading || projects.length === 0;

  if (!open) return null;

  return (
    <dialog className="modal" open>
      <div className="modal-box">
        <form onSubmit={onSubmit}>
          <h3 className="text-lg font-bold">Duplicate {resourceLabel}</h3>
          <p className="mt-2 text-sm text-gray-600">
            Choose the target project for {count} selected {resourceLabel}.
          </p>
          <div className="mt-4">
            {isProjectsLoading ? (
              <div className="flex h-10 items-center text-sm text-gray-500">Loading projects...</div>
            ) : (
              <ProjectTargetField
                defaultProjectId={defaultProjectId}
                initialNextPage={initialNextPage}
                initialProjects={projects}
              />
            )}
          </div>
          <div className="modal-action">
            <button
              type="button"
              className={`btn btn-sm btn-secondary ${isSubmitDisabled ? 'btn-disabled' : ''}`}
              disabled={isSubmitDisabled}
              onClick={onClose}
            >
              Cancel
            </button>
            <SubmitButton label="Copy selected" isDisabled={isSubmitDisabled} isPending={isPending} />
          </div>
        </form>
      </div>
      <form method="dialog" className="modal-backdrop">
        <button onClick={onClose}>close</button>
      </form>
    </dialog>
  );
};

BulkDuplicateModal.propTypes = {
  count: PropTypes.number.isRequired,
  defaultProjectId: PropTypes.string.isRequired,
  initialNextPage: PropTypes.string,
  isPending: PropTypes.bool,
  isProjectsLoading: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  projects: PropTypes.arrayOf(PropTypes.object),
  resourceLabel: PropTypes.string.isRequired,
};

export default BulkDuplicateModal;
